import { pickBy, identity } from "lodash"

class GetChannelTypesRequest {

    constructor({ 
        communityId,
        entityType 
    }) {
        this.communityId = communityId
        this.entityType = entityType
    }

    getPayload = () => {
        
        const payload = {
            "community_id": this.communityId,
            "entity_type": this.entityType,
        }

        return pickBy(payload, identity)
    }
    
}

export default GetChannelTypesRequest
